// AC-BIN-034a: 取引中断中のコマ (JEPX SuspenseCode 由来) の判定と、 提出確認モーダルの警告。
import {
  BiddingIntradayMarketSuspenseState,
  type BiddingMarketProduct,
} from '@ebalance/proto/bffuser/v1/bidding_intraday_market_model_pb'
import type { TFunction } from 'i18next'

import type { ViolationSection } from '~/components/bidding/common/SubmitConfirmModal'
import { formatKomaLabel } from '~/models/komaLabel'

export const suspendedTimeCodesOf = (
  products: ReadonlyArray<
    Pick<BiddingMarketProduct, 'timeCode' | 'suspenseState'>
  >,
): ReadonlySet<number> =>
  new Set(
    products
      .filter(
        (p) => p.suspenseState === BiddingIntradayMarketSuspenseState.SUSPENDED,
      )
      .map((p) => p.timeCode),
  )

/**
 * 提出対象の札のうち取引中断中のコマを警告する節。 提出は止めないので
 * `SubmitConfirmModal` の `warningSections` に渡す。 件数と明細はコマ単位で数える
 * (同じコマに複数の札があっても 1 件)。 該当が無ければ明細が空になり描画されない。
 */
export const buildSuspendedKomaWarningSection = (
  targets: ReadonlyArray<{ timeCode: number }>,
  suspendedTimeCodes: ReadonlySet<number>,
  t: TFunction,
): ViolationSection => {
  const komas = [
    ...new Set(
      targets
        .map((b) => b.timeCode)
        .filter((koma) => suspendedTimeCodes.has(koma)),
    ),
  ].sort((a, b) => a - b)
  return {
    title: t('page:biddingIntraday.submit.suspendedWarningTitle', {
      count: komas.length,
    }),
    body: t('page:biddingIntraday.submit.suspendedWarningBody'),
    details: komas.map((koma) => formatKomaLabel(t, koma)),
  }
}
